import React from 'react';
import { TenureTracker } from './TenureTracker';

export const EligibilityChecklist = ({ eligibility, profile }) => {
  return <TenureTracker profile={profile} />;
};